
export default {
  name: "EtiquetaVersionHistory",
  props: {
    history: { type: Array, default: () => [] },
    publishedId: { type: Number, default: null },
    origin: { type: String, default: "novo" },
    hasPublication: { type: Boolean, default: false },
  },
  methods: {
    isCurrent(version) {
      return Number(version.id) === Number(this.publishedId);
    },
    canRestore(version) {
      return version.status !== "rascunho" && !this.isCurrent(version);
    },
    statusLabel(version) {
      if (this.isCurrent(version)) return "Em uso";
      return (
        {
          rascunho: "Rascunho",
          publicado: "Publicada",
          substituido: "Anterior",
          arquivado: "Arquivada",
        }[version.status] || version.status
      );
    },
    badgeClass(version) {
      if (this.isCurrent(version)) return "badge-light-success";
      return version.status === "rascunho"
        ? "badge-light-warning"
        : "badge-light";
    },
    statusClass(version) {
      if (this.isCurrent(version)) return "current";
      return version.status === "rascunho" ? "draft" : "old";
    },
    dateLabel(version) {
      const value = version.publicado_em || version.atualizado_em;
      if (!value) return "Data não informada";
      return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(value));
    },
    sourceNumber(id) {
      const source = this.history.find(
        (item) => Number(item.id) === Number(id)
      );
      return source ? source.numero : "anterior";
    },
  },
};
